var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-center align-items-center" },
      [
        _c(
          "CheckPermission",
          { attrs: { permission: "*" } },
          [
            _c(
              "b-button",
              {
                staticClass: "btn-icon rounded-circle p-3 mr-3",
                attrs: {
                  variant: "secondary",
                  size: "sm",
                  "data-cy": "details"
                },
                on: {
                  click: function($event) {
                    return _vm.showDetails(_vm.file)
                  }
                }
              },
              [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
              1
            )
          ],
          1
        ),
        _vm.view === "recibidos"
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Desplegar acciones",
                    expression: "'Desplegar acciones'"
                  }
                ]
              },
              [
                _c(
                  "b-dropdown",
                  {
                    attrs: { variant: "link", "no-caret": "", right: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("feather-icon", {
                                staticClass: "align-middle text-body",
                                attrs: {
                                  "data-cy": "gear-button",
                                  width: "24px",
                                  height: "24px",
                                  icon: "SettingsIcon"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3165136339
                    )
                  },
                  [
                    _c(
                      "CheckPermission",
                      { attrs: { permission: "ED101" } },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: { "data-cy": "convert-a-file" },
                            on: {
                              click: function($event) {
                                return _vm.convertFile()
                              }
                            }
                          },
                          [
                            _c("vs-icon", { attrs: { icon: "description" } }),
                            _vm._v(" Convertir a Expediente ")
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.view === "recibidos"
                      ? _c(
                          "b-dropdown-item",
                          {
                            attrs: { "data-cy": "mark-read" },
                            on: {
                              click: function($event) {
                                return _vm.markRead()
                              }
                            }
                          },
                          [
                            _c("vs-icon", { attrs: { icon: "thumb_up" } }),
                            _vm._v(" Acuse recibo ")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.view === "recibidos"
                      ? _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal",
                                value: "modal-process-" + _vm.file.id,
                                expression: "`modal-process-${file.id}`"
                              }
                            ],
                            attrs: { "data-cy": "mark-return" },
                            on: {
                              click: function($event) {
                                return _vm.returnFile()
                              }
                            }
                          },
                          [
                            _c("vs-icon", { attrs: { icon: "reply" } }),
                            _vm._v(" Devolver ")
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c("span")
              ],
              1
            )
          : _vm._e(),
        _c(
          "b-modal",
          {
            ref: "modal-process-" + _vm.file.id,
            attrs: {
              id: "modal-process-" + _vm.file.id,
              title: _vm.titleModal + " el documento #" + _vm.file.id,
              "ok-title": "Vale",
              size: "lg",
              "hide-footer": ""
            }
          },
          [
            _c("ModalProcessDD", {
              attrs: { file: _vm.file, process: _vm.processAction },
              on: { "close-modal": _vm.closeModal }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }